import { useState } from 'react'
import { useConfirmationModal, useHover } from '../../../hooks'
import { ReactComponent as DeleteIcon } from '../../../images/icons/delete.svg'
import { ReactComponent as AttachmentIcon } from '../../../images/icons/attachment.svg'
import { DEFAULT_ANIMATION } from '../../../lib/const'
import { apiErrorMessage } from '../../../lib/utils'
import httpClient from '../../../httpClient'

const ImagePreview = ({ image, labOrderGuid, productType, onDeleted }) => {
  const [hoverRef, isHovered] = useHover()
  const { Modal, setIsOpen } = useConfirmationModal()
  const [deleting, setDeleting] = useState(false)
  const { preview, path, uploading } = image

  const handleDelete = async () => {
    if (deleting) return

    try {
      setIsOpen(false)
      setDeleting(true)
      const endpoint = productType === 'multi-opening'
        ? `lab_orders/${labOrderGuid}/multi_openings_line_items/photographs`
        : `lab_orders/${labOrderGuid}/photographs`
      await httpClient.delete(endpoint, {
        data: { ids: [image.id] },
      })
      onDeleted(image.id)
    } catch (error) {
      alert(apiErrorMessage(error))
    } finally {
      setDeleting(false)
    }
  }

  if (uploading) {
    return (
      <div className="picture-element-print-order" ref={hoverRef}>
               <div style={{ textAlign: 'center', marginTop: '8px', color: '#4d4d4d' }}>
          Uploading image...
        </div>
        <div className="info-container-print-picture">
          <div className="info-print-order-product-container">
            <div className="icon small right-margin x2 w-embed">
              <AttachmentIcon />
            </div>
            <div style={{ textAlign: 'center' }}>{path}</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="picture-element-print-order" ref={hoverRef}>
      <img src={preview} loading="lazy" alt={`Uploaded ${path}`} className="img-print-order" />
      <div className="info-container-print-picture">
        <div className="info-print-order-product-container">
          <div className="icon small right-margin x2 w-embed">
            <AttachmentIcon />
          </div>
          <div style={{ lineBreak: 'anywhere', textAlign: 'center' }}>{path}</div>
        </div>
      </div>
      <div className="w-layout-grid grid-button-picture-print-order">
        <div
          className="print-delete-button"
          style={{ opacity: isHovered ? 1 : 0, transition: DEFAULT_ANIMATION }}
          onClick={() => setIsOpen(true)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') setIsOpen(true)
          }}
          role="button"
          tabIndex={0}
          aria-label="Delete image"
        >
          <div className="icon small w-embed">
            <DeleteIcon />
          </div>
        </div>
      </div>
      <Modal onContinue={handleDelete} />
    </div>
  )
}

export default ImagePreview
